import { InlineEditor } from './inline-editor.js';

/**
 * CompanyTotalReturn
 *
 * State shape (set on the server via SetCtrlState):
 *   startingAmount        — TwoWay editable
 *   priceGainRatio        — priceGain      / startingAmount0   (server-computed, stable)
 *   cashDividendsRatio    — cash dividends / startingAmount0   (server-computed, stable)
 *   dividendsRatio        — dividend contribution (residual, feeds Total Gain) / startingAmount0
 *   endBalanceRatio       — endBalance     / startingAmount0   (server-computed, stable)
 *   priceGrowthCagr       — does not depend on startingAmount
 *   totalReturnCagr       — does not depend on startingAmount
 *   currencyID, dividendCurrencyID, mode, reinvest, startDate, endDate, yearsFraction
 *
 * Computed fields below scale ratios by the current `startingAmount`,
 * so inline-edits trigger an instant recalculation with no server round-trip.
 */
class CompanyTotalReturn extends Tango.Component {

	widgetWillMount() {
		// Absolute monetary values, derived from ratios × startingAmount.
		this.defineComputed('priceGain', () =>
			this.state.startingAmount * this.state.priceGainRatio);

		// Cash dividends received — the "Dividends" row, constant across the reinvest toggle.
		this.defineComputed('cashDividends', () =>
			this.state.startingAmount * this.state.cashDividendsRatio);

		// Dividend contribution (cash + appreciation of reinvested shares) — the residual that
		// closes Total Gain = Price Gain + this. Equals cashDividends when reinvest is OFF.
		this.defineComputed('dividends', () =>
			this.state.startingAmount * this.state.dividendsRatio);

		this.defineComputed('totalGain', () =>
			this.state.priceGain + this.state.dividends);

		this.defineComputed('endBalance', () =>
			this.state.startingAmount * this.state.endBalanceRatio);

		// Total Return percentage: endBalance / startingAmount − 1.
		// Equivalent to (endBalanceRatio − 1), so it's actually invariant under
		// startingAmount changes — but we expose it as a computed for consistency
		// with the other monetary fields and to keep the binding live.
		this.defineComputed('totalReturn', () =>
			this.state.endBalanceRatio - 1);
	}

	widgetDidMount() {
		InlineEditor.attach(this.root, this.state, this.fields);
	}
}

Tango.registerComponent(CompanyTotalReturn);